var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"closable":false,"has-icon":true,"icon":_vm.icon}},[_c('div',{staticClass:"notification-title",staticStyle:{"min-height":"46px","line-height":"46px"}},[_vm._t("title")],2),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }